<template>
  <div>
    <!-- 资金/入金信息汇总 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.depositInformation')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.bank_method" type="card" @tab-click="search">
          <!--  全部-->
          <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
          <!--  状态 -->
          <el-tab-pane v-for="(item, index) in orderStatusList" :key="index" :label="item.value"
            :name="item.key + ''"></el-tab-pane>
        </el-tabs>
        <!-- 操作 -->
        <div class="btn">
          <!-- 流水匹配 -->
          <el-button type="success" @click="bankReMatch">{{ $t('message.flowMatching')
          }}</el-button>
          <!-- 上传流水 -->
          <el-button type="primary" class="primary" @click="$refs.uploadStream.dialogVisible = true">{{
            $t('message.uploadStream') }}</el-button>
          <el-button type="primary" class="primary" @click="$refs.flowMatching.dialogVisible = true">测试{{
            $t('message.uploadStream') }}</el-button>
        </div>
      </div>
      <div class="search">
        <div class="operationContainer">
          <div class="leftContainer">
            <!--  流水明细模糊匹配-->
            <div class="item">
              <el-input v-model="datas.account" :placeholder="$t('message.flowDetailFuzzyMatching')" class="Container"
                onfocus="this.select()" />
            </div>
            <!-- 金额精确匹配-->
            <div class="item">
              <el-input v-model="datas.amount" :placeholder="$t('message.exactMatchingOfAmounts')" class="Container"
                onfocus="this.select()" />
            </div>
            <!-- 开始时间-->
            <div class="item">
              <el-date-picker v-model="datas.datetimePayStart" :placeholder="$t('message.startDate')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <!-- 结束时间-->
            <div class="item">
              <el-date-picker v-model="datas.datetimePayEnd" :placeholder="$t('message.dateClosed')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <!-- 匹配状态-->
            <div class="item">
              <el-select v-model="datas.is_match" :placeholder="$t('message.matchingState')">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="item">
              <!--  搜索 -->
              <el-button type="primary" @click="search">
                {{ $t("message.search") }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="total">
        <!--  出金金额（円 -->
        <span>{{ $t('message.withdrawalAmount') }}:{{ formatNumber(amount_out) }}</span>
        <!--  出金金额（円 -->
        <span>{{ $t('message.depositAmount') }}: {{ formatNumber(amount_in) }}</span>
      </div>
      <div class="table">
        <el-table :data="tableData" :header-cell-style="{ background: '#EDEFF4' }" :cell-style="{
          'text-align': 'center',
        }" @selection-change="handleSelectionChange" ref="multipleTable" @cell-click="labelSelection"
          :row-class-name="tableRowClassName" max-height="900">
          <el-table-column align="center" label="NO" prop="rowNumber" width="45">
          </el-table-column>
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>
          <!--  导入日期-->
          <el-table-column align="center" :label="$t('message.importDate')" prop="created_at" width="100">
          </el-table-column>
          <!--  银行流水日期-->
          <el-table-column align="center" :label="$t('message.bankStatementDate')" prop="pay_at" width="100">
          </el-table-column>
          <!--  类型-->
          <el-table-column align="center" :label="$t('message.Kintype')" prop="bank_method_name" width="80">
          </el-table-column>
          <!--  流水编号-->
          <el-table-column align="center" :label="$t('message.flowNumber')" prop="serial_number">
          </el-table-column>
          <!-- 流水明细 -->
          <el-table-column align="center" :label="$t('message.journalDetail')" prop="account">
          </el-table-column>
          <!-- 出金金额（円） -->
          <el-table-column align="center" :label="$t('message.withdrawalAmount')" prop="amount_out">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.amount_out) }}
            </template>
          </el-table-column>
          <!-- 入金金额（円） -->
          <el-table-column align="center" :label="$t('message.depositAmount')" prop="amount_in">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.amount_in) }}
            </template>
          </el-table-column>
          <!-- 当时余额 -->
          <!-- <el-table-column align="center" :label="$t('message.currentBalance')" prop="balance">
          </el-table-column> -->
          <!-- 其他备注 -->
          <el-table-column align="center" :label="$t('message.otherRemarks')" prop="remark">
          </el-table-column>
          <!-- 匹配状态 -->
          <el-table-column align="center" :label="$t('message.matchingState')" width="100">
            <template slot-scope="scope">
              <div>
                {{ scope.row.user_bill ? '成功' : '未反映' }}
                <p> {{ scope.row.match_at ? scope.row.match_at : '' }}</p>
                <p>
                  <!-- 标记已人工审核 -->
                  <el-button type="text" size="small" v-if="scope.row.is_personal_confirmed == 0"
                    @click="signPersonConfirmed(scope.row)">
                    {{ $t('message.markManuallyReviewed') }}
                  </el-button>
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 备注 -->
          <el-table-column align="center" :label="$t('message.remarks')" width="150">
            <template slot-scope="scope">
              <div>
                <el-input type="textarea" v-model="scope.row.deal_remark"
                  @blur="updateDealRemark(scope.row)"></el-input>
              </div>
            </template>
          </el-table-column>
          <!-- 系统流水号 -->
          <el-table-column align="center" :label="$t('message.systemSerialNumber')">
            <template slot-scope="scope">
              <div v-if="scope.row.user_bill">
                {{ scope.row.user_bill.serial_number }}
              </div>
            </template>

          </el-table-column>
          <!-- 订单号/配送单号 -->
          <!-- prop="order_time_node.datetime_pay_submit" -->
          <el-table-column align="center" :label="$t('message.orderDistribution')">
            <template slot-scope="scope">
              <div v-if="scope.row.user_bill">
                {{ scope.row.user_bill.order_sn }}
              </div>
            </template>
          </el-table-column>
          <!-- 客户信息 -->
          <el-table-column align="center" :label="$t('message.userInfo')">
            <template slot-scope="scope">
              <div v-if="scope.row.user_bill">
                <p> {{ scope.row.user_bill.user.realname }}</p>
                <p> {{ scope.row.user_bill.user.id }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 出入金明细（内容） -->
          <el-table-column align="center" :label="$t('message.paymentDetailsContents')">
            <template slot-scope="scope">
              <div v-if="scope.row.user_bill">
                <p> {{ scope.row.user_bill.bill_type_name }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[20, 50, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 上传流水 -->
    <uploadStream ref="uploadStream" />
    <!-- 流水匹配 -->
    <flowMatching ref="flowMatching" />
    <!-- 流水匹配结果 -->
    <matchingDetails ref="matchingDetails" :detail="conflictDetail" />
  </div>
</template>
<script>

import uploadStream from './components/uploadStream'
import flowMatching from './components/flowMatching'
import matchingDetails from './components/matchingDetails'
export default {
  components: {
    uploadStream, flowMatching, matchingDetails
  },
  data() {
    return {
      datas: {
        is_match: "",
        datetimePayStart: "",
        datetimePayEnd: "",
        bank_method: "",
        amount: "",
        serial_number: "",
        account: '',
        page: 1,
        pageSize: 20,
      },

      total: 0,
      tableData: [],
      orderStatusList: [
        { value: '楽天銀行', key: '2' },
        { value: 'ゆうちょ銀行', key: '3' },
        { value: 'paypay銀行', key: '4' },
      ],
      options: [
        { label: 'すべて', value: '0' },
        { label: '未反映', value: '1' },
        { label: '成功', value: '2' },
        { label: '未成功', value: '3' },
      ],
      selectList: [],
      amount_out: 0,
      amount_in: 0,
      conflictDetail: {},//流水匹配详情
    };
  },
  created() {
    this.bankList()
  },
  methods: {
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.user_bill == null && row.is_personal_confirmed != 1) {
        return 'danger-row';
      }
      else if (row.user_bill != null && row.user_bill.status == 0) {
        return 'warning-row';



      }
      return '';
    },
    // 银行账单--列表
    bankList() {
      this.amount_out = 0
      this.amount_in = 0
      this.$api.financialApi.bankList(this.datas).then(res => {

        this.tableData = res.data.data
        this.tableData.forEach(item => {
          this.amount_in += item.amount_in - 0
          this.amount_out += item.amount_out - 0
        })
        this.total = res.data.total
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.bankList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.bankList();
    },
    // 搜索订单
    search() {
      this.datas.page = 1;
      this.bankList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    //重新匹配
    bankReMatch() {
      let ids = []
      this.selectList.forEach(item => {
        ids.push(item.id)
      })
      this.$api.financialApi.bankReMatch({ ids }).then(res => {
        this.bankList()
        this.conflictDetail = res.data
        this.$refs.matchingDetails.dialogVisible = true
      })
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    //批量修改处理备注
    updateDealRemark(item) {
      let datas = {

        ids: [item.id],
        deal_remark: item.deal_remark

      }
      this.$api.financialApi.updateDealRemark(datas).then(res => {

      })
    },
    //标记已人工审核
    signPersonConfirmed(item) {
      let datas = {
        bank_bill_id: item.id,
      }
      this.$confirm('确认已人工审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.financialApi.signPersonConfirmed(datas).then(res => {
          this.$message.success(res.msg)
          this.bankList()
        })
      }).catch(() => {
      });


    }
  }
}
</script>
<style lang='scss' scoped>
.tabs {
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: 0;

    .el-button {
      margin: 0 30px;
    }
  }
}

.table {
  margin: 20px 0;

}

.item {
  margin-right: 20px;
}

.el-select {
  width: 180px;
}

.operationContainer {
  display: flex;

  .leftContainer {
    flex: 7;
  }

  .rightContainer {
    flex: 1;

  }
}

/deep/.el-textarea__inner {
  min-height: 100px !important;
  padding: 3px
}

/deep/.el-table tbody .warning-row {
  background-color: rgba(230, 162, 60, 0.5) !important;

}

/deep/.el-table tbody .warning-row:hover>td {
  background-color: rgba(230, 162, 60, 0.5) !important;

}

/deep/.el-table tbody .danger-row {
  background-color: rgba(245, 108, 108, 0.5) !important;
}

/deep/.el-table tbody .danger-row:hover>td {
  background-color: rgba(245, 108, 108, 0.5) !important;
}

/deep/.el-table__header {
  position: sticky !important;
  top: 0;
  left: 0;
}

.total {
  margin: 20px;
  font-size: 20px;
  display: none;

  span {
    margin-right: 100px;
    color: #B4272D;
    font-weight: 600;
  }


}
</style>